module.exports = __webpack_public_path__ + "img/karunia.597955a1.jpg";